module.exports = __webpack_public_path__ + "static/media/starConfetti.a51a9924.svg";